<template>
  <v-card>
    <v-card-title class="py-1">{{ $t('message.common.approvalHours') }}</v-card-title>
    <v-card-text>
     <v-row>
       <v-col class="d-flex" cols="12" sm="6" lg="3">
        <!-- ${val.number || ''} -  --><v-autocomplete :items="listOfResponsibleProjects" :item-text="(val) => `${val.name || ''}`" item-value="id" :label="$t('message.timer.selectProjects')" hide-details outlined v-model="filterObj.projects" multiple>
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.name }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption">(+{{ filterObj.projects.length - 1 }} others)</span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" lg="3">
        <v-autocomplete :items="getUsers" :item-text="(val) => `${val.name || ''}`" item-value="id" :label="$t('message.common.selectUsers')" hide-details outlined v-model="filterObj.users" multiple>
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.name }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption">(+{{ filterObj.users.length - 1 }} others)</span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" lg="2">
        <v-menu v-model="startMenu" :close-on-content-click="false" ransition="scale-transition" offset-y min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field clearable readonly v-on="on" hide-details v-model="filterObj.start" outlined @click:clear="$nextTick(() => startPicker = null)" :label="$t('message.common.startDate')"></v-text-field>
          </template>
          <v-date-picker v-model="startPicker"  @input="startMenu = false" color="primary" first-day-of-week='1'></v-date-picker>
        </v-menu>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" lg="2">
        <v-menu v-model="endMenu" :close-on-content-click="false" ransition="scale-transition" offset-y min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field clearable readonly v-on="on" hide-details v-model="filterObj.end" outlined @click:clear="$nextTick(() => startPicker = null)" :label="$t('message.common.endDate')"></v-text-field>
          </template>
          <v-date-picker v-model="endPicker"  @input="endMenu = false" color="primary" first-day-of-week='1'></v-date-picker>
        </v-menu>
      </v-col>
      <v-col class="d-flex pr-5" cols="12" sm="6" lg="2">
         <v-btn fab dark small color="primary" class="mb-7" @click="filterHours()">{{$t('message.timer.go')}}</v-btn>
      </v-col>
      <!-- Tabs -->
      <v-col class="d-flex pr-5 pt-0" cols="12" sm="12" lg="12" @click="setApproveTab">
        <v-tabs v-model="active" dark slider-color="white" id="tab" centered fixed-tabs background-color="primary">
          <v-tab class="mt-2" v-if="!this.activeUser.canDeliverHours" @click="getHourList('not_delivered')">
            <v-icon color="white" small class="pr-2">mdi-clock</v-icon>
            <span class="hidden-sm-and-down">{{$t('message.timer.deliver')}}</span>
          </v-tab>
          <v-tab class="mt-2" @click="getHourList('delivered')">
            <v-icon color="white" small class="pr-2">mdi-clock</v-icon>
            <span class="hidden-sm-and-down">{{$t('message.timer.approveHours')}}</span>
          </v-tab>
          <v-tab class="mt-2" @click="getHourList('approved')">
            <v-icon color="white" small class="pr-2">mdi-alarm-check</v-icon>
            <span class="hidden-sm-and-down">{{$t('message.timer.approvedHours')}}</span>
          </v-tab>
          <v-tab class="mt-2" @click="getHourList('not_approved')">
            <v-icon color="white" small class="pr-2">mdi-alarm-off</v-icon>
            <span class="hidden-sm-and-down">{{$t('message.timer.notApprovedHours')}}</span>
          </v-tab>
          <v-tab-item v-for="(item, index) in tabItems" :key="index">
          <v-card>
            <v-card-title>
              <v-row align="center">
                <v-col class="d-flex mr-auto" cols="12" sm="6" lg="2">
                  <v-btn color="primary" class="mx-1" v-if="item.name === 'deliverTab'" @click="deliverHours()">{{$t('message.timer.deliver')}}</v-btn>
                  <v-btn color="success" class="mx-1" v-if="item.name == 'approveTab' || item.name == 'notApprovedTab'" @click="approveOrnotApproveHours()">{{$t('message.timer.approve')}}</v-btn>
                  <v-btn color="error" class="mx-1" v-if="item.name == 'approveTab' || item.name == 'approvedTab'" @click="notApproveDialogHandler">{{$t('message.timer.notApprove')}}</v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-data-table :headers="headers" :items="hoursList" show-select item-key="id" v-model="selected" :must-sort='true' dense :loading="loading">
                  <template v-slot:item.data-table-select="{ isSelected, select }">
                    <v-simple-checkbox :ripple="false" color="primary" :value="isSelected" @input="select($event)"></v-simple-checkbox>
                  </template>
                  <template v-slot:item.notapprovedcomment="{ item }" v-if="activeUser.canDeliverHours ? active === 2 : active === 3">
                    {{ item.notapprovedcomment }}
                  </template>
                  <template v-slot:item.hours="{ item }">
                    {{ item.hours | replaceDotWithComma }}
                  </template>
                  <template v-slot:item.action="{ item }" v-if="activeUser.canDeliverHours ? active !== 1 : active !== 2 && active !== 0">
                    <v-icon small class="mr-2" @click="getSingleEntryHandler(item.id)">mdi-pencil</v-icon>
                    <v-icon small @click="deleteEntryHandler(item.id)">mdi-delete</v-icon>
                  </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    </v-card-text>
    <!-- Dialog for not approve comments-->
    <v-dialog v-model="notApproveCommentsDialog" max-width="500px">
      <v-form ref="commentForm">
        <v-card>
          <v-card-title>
            {{$t('message.timer.notApproved')}}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-4">
            <v-textarea outlined textarea :label="$t('message.common.comments')" v-model="notApproveComments" :rules="$_requiredValidation"></v-textarea>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="notApproveCommentsHandler">{{$t('message.common.save')}}</v-btn>
            <v-btn color="error" @click.stop="notApproveCommentsDialog=false">{{$t('message.common.close')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- Dialog for edit-->
    <v-dialog  v-model="editHourDialog" max-width="700px">
      <form-template :references.sync="formReferences" :model="timerObj" ref="hourReference"></form-template>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import FormTemplate from '@/components/FormTemplate'
import CONSTANTS from '@/assets/json/constants.json'
import moment from 'moment'
import _localStorage from '@/plugins/local_storage'
export default {
  data () {
    return {
      MODULE: 'hourloggings',
      listOfUsers: [],
      listOfResponsibleProjects: [],
      startMenu: false,
      endMenu: false,
      userList: [],
      filterObj: {
        type: 'working',
        start: moment().startOf('month').format('DD.MM.YYYY'),
        end: moment().endOf('month').format('DD.MM.YYYY')
      },
      startPicker: '',
      endPicker: '',
      selected: [],
      hoursList: [],
      tabItems: [{
        name: 'approveTab'
      }, {
        name: 'approvedTab'
      }, {
        name: 'notApprovedTab'
      }],
      timerObj: {},
      search: '',
      loading: false,
      growValue: true,
      active: null,
      notApproveComments: '',
      notApproveCommentsDialog: false,
      editHourDialog: false,
      activeUser: {}
    }
  },
  components: {
    FormTemplate
  },
  mounted () {
    let getActiveuser = _localStorage.get(process.env.VUE_APP_USER) // this.$cookie.get(process.env.VUE_APP_USER)
    this.activeUser = getActiveuser ? JSON.parse(getActiveuser) : {}
    if (this.activeUser.id) {
      this.activeUser.id = parseInt(this.activeUser.id)
      this.getCurrentUserObj(this.activeUser.id)
    }
    this.active = parseInt(localStorage.getItem('currentApproveTab'))
    this.filterHours()
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.HOURS) {
        let payload = { ids: data.ids, url: `${this.HOURS}/delete_multiple`, module: 'HOURS' }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.HOURS) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.filterHours()
      }
    })
  },
  methods: {
    getCurrentUserObj (id) {
      this.$api.execute('get', `users/${id}`)
        .then((response) => {
          let userObj = response.data || {}
          this.activeUser.canDeliverHours = userObj.can_deliver_hours ? userObj.can_deliver_hours : false
          if (!this.activeUser.canDeliverHours) this.tabItems.splice(0, 0, { name: 'deliverTab' })
        })
    },
    getResponsibleProjects () {
      this.$api.execute('get', `projects/get_responsible_projects`)
        .then((response) => {
          this.listOfResponsibleProjects = this.$format.cloneVariable(response.data)
        })
    },
    setApproveTab () {
      localStorage.setItem('currentApproveTab', this.active)
    },
    filterHours () {
      switch (this.active) {
        case 0:
          this.getHourList('not_delivered')
          break
        case 1:
          this.getHourList('delivered')
          break
        case 2:
          this.getHourList('approved')
          break
        case 3:
          this.getHourList('not_approved')
          break
        default:
          this.getHourList('not_delivered')
          break
      }
    },
    getHourList (type) {
      this.loading = true
      let model = this.filterObj
      let transformDate = { date: { list: ['start', 'end'], from: 'DD.MM.YYYY', to: 'YYYY-MM-DDTHH:mm:ss' } }
      model = this.$format.formatModel(model, transformDate)
      model.state = type
      if (!model.projects) model.projects = []
      model.for_approval = true
      this.$api.execute('post', `${this.MODULE}/filter`, model)
        .then((response) => {
          let transformData = { date: { list: ['date'], from: 'YYYY-MM-DDTHH:mm:ss', to: 'DD.MM.YYYY' } }
          let list = this.$format.formatListModel(response.data, transformData)
          this.hoursList = list
          this.loading = false
        })
    },
    notApproveCommentsHandler () {
      if (this.$refs.commentForm.validate()) {
        this.approveOrnotApproveHours()
      }
    },
    deliverHours () {
      if (this.selected.length !== 0) {
        let hourIds = this.selected.map(x => x.id)
        let model = { ids: hourIds, parameters: { state: CONSTANTS.DELIVERED } }
        this.$api.execute('put', `${this.MODULE}/bulk_update`, model)
          .then((response) => {
            this.filterHours()
            this.selected = []
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.timer.deliveredSuccessfully') })
          })
      } else {
        this.$root.$emit('snackbar', {
          snackbar: true,
          color: 'error',
          text: this.$t('message.timer.selectEntries')
        })
        return false
      }
    },
    approveOrnotApproveHours () {
      let model = { ids: [] }
      if (this.notApproveComments === '') {
        model.parameters = { state: 'approved' }
      } else {
        model.parameters = { state: 'not_approved', not_approved_comment: this.notApproveComments }
      }
      if (this.selected.length !== 0) {
        for (let i = 0; i < this.selected.length; i++) {
          model.ids.push(this.selected[i].id).toString()
        }
        this.$api.execute('put', `${this.MODULE}/bulk_update`, model).then(response => {
          this.filterHours()
          this.selected = []
          this.notApproveComments = ''
          this.notApproveCommentsDialog = false
        })
      } else {
        this.$root.$emit('snackbar', {
          snackbar: true,
          color: 'error',
          text: this.$t('message.timer.selectEntries')
        })
        return false
      }
    },
    notApproveDialogHandler () {
      if (this.selected.length !== 0) {
        this.notApproveCommentsDialog = true
        this.notApproveComments = ''
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.timer.selectEntries') })
      }
    },
    closeDialogHandler () {
      this.editHourDialog = false
      if (this.$refs && this.$refs.hourReference) this.$refs.hourReference.$refs.validateForm.reset()
    },
    getSingleEntryHandler (id) {
      this.$api.execute('get', `${this.MODULE}/${id}`).then(response => {
        let hour = response.data
        hour.hours = parseFloat(hour.hours).toFixed(2)
        hour.datePicker = null
        let transformNumber = { number: { list: ['hours', 'findersfee'], format: 'replaceDotWithComma' } }
        hour = this.$format.formatModel(hour, transformNumber)
        let transformData = { date: { list: ['date'], from: 'YYYY.MM.DD', to: 'DD.MM.YYYY' } }
        let model = this.$format.formatModel(hour, transformData)
        let employee = this.getUsers.find(x => x.id === model.projectmemberid)
        model.employee_name = employee && employee.name ? employee.name : ''
        if (response.data) this.timerObj = model
        this.editHourDialog = true
      })
    },
    updateHandler () {
      if (this.$refs.hourReference.$refs.validateForm.validate()) {
        this.loading = true
        let model = this.$format.cloneVariable(this.timerObj)
        model.state = model.id ? model.state : this.NOT_DELIVERED
        let transformNumber = { number: { list: ['hours', 'findersfee'], format: 'replaceCommaWithDot' } }
        model = this.$format.formatModel(model, transformNumber)
        let transformData = { date: { list: ['date'], from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' } }
        model = this.$format.formatModel(model, transformData)
        model.type = CONSTANTS.WORKING
        let url = this.MODULE
        this.$api.saveUpdateHandler(url, model)
          .then((response) => {
            // this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.timer.deliveredSuccessfully') })
            this.closeDialogHandler()
            this.filterHours()
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    deleteEntryHandler (id) {
      let ids = [id]
      let payload = { ids, url: `${this.MODULE}/delete_multiple`, module: this.HOURS }
      this.$store.commit('showDeleteDialog', payload)
    }
  },
  created () {
    this.getResponsibleProjects()
    this.$store.dispatch('getUsers')
    this.$store.dispatch('getActivities')
    this.$store.dispatch('getWorktypes')
  },
  computed: {
    ...mapGetters(['formType', 'getActivities', 'getWorktypes', 'getUsers']),
    headers () {
      let headers = []
      headers = [{
        text: this.$t('message.stamp.project'),
        value: 'project_name'
      }, {
        text: this.$t('message.common.employee'),
        value: 'employee_name'
      }, {
        text: this.$t('message.common.date'),
        value: 'date'
      }, {
        text: this.$t('message.layout.activities'),
        value: 'activity_name'
      }, {
        text: this.$t('message.timer.hours'),
        value: 'hours'
      }, {
        text: this.$t('message.common.comments'),
        value: 'comments'
      }, {
        text: '',
        value: 'action',
        sortable: false
      }]
      if (this.active === 2) {
        headers.splice(5, 0, {
          text: this.$t('message.timer.notApproved'),
          value: 'not_approved_comment'
        })
      }
      return headers
    },
    formReferences () {
      return {
        title: this.timerObj.id ? `${this.$t('message.timer.editHours')} ${this.timerObj.employee_name ? `: Employee- ${this.timerObj.employee_name}` : ''}` : this.$t('message.timer.addHours'),
        properties: [{
          model: 'projectid',
          type: this.formType.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.listOfResponsibleProjects,
          select_text: (val) => `${val.name}`, // `${val.firstname || ''} ${val.lastname || ''}`,
          select_value: 'id',
          disabled: this.isReadOnly,
          label: this.$t('message.layout.projects'),
          class: 'xs12'
        }, /* {
          model: 'worktypeid',
          type: this.formType.AUTO_COMPLETE,
          rules: [],
          items: this.getWorktypes,
          is_list: false,
          click: (search) => false,
          term: '',
          disabled: this.isReadOnly,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.layout.worktypes'),
          class: 'xs12'
        }, */ /* {
          model: 'task',
          type: this.formType.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.common.task'),
          class: 'xs12'
        }, */ {
          model: 'date',
          type: this.formType.DATEPICKER,
          rules: this.$_requiredValidation,
          picker: 'datePicker',
          menu: 'dateMenu',
          color: 'primary lighten-1',
          label: '',
          disabled: this.isReadOnly,
          class: 'sm6 xs12'
        }, {
          model: 'hours',
          type: this.formType.TEXT,
          rules: this.$_HourValidation,
          label: this.$t('message.timer.hours'),
          class: 'sm6 xs12'
        }, {
          model: 'activityid',
          type: this.formType.AUTO_COMPLETE,
          rules: [],
          items: this.getActivities,
          is_list: false,
          click: (search) => false,
          term: '',
          disabled: this.isReadOnly,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.layout.activities'),
          class: 'xs12'
        }, {
          model: 'finder',
          type: this.formType.AUTO_COMPLETE,
          rules: [],
          items: this.getUsers,
          is_list: false,
          click: (search) => false,
          term: '',
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.timer.finder'),
          class: 'sm6 xs12'
        }, {
          model: 'findersfee',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.timer.findersFee'),
          class: 'sm6 xs12'
        }, {
          model: 'comments',
          type: this.formType.TEXTAREA,
          rules: [],
          disabled: this.isReadOnly,
          label: this.$t('message.common.comments'),
          class: 'xs12'
        }, {
          model: 'not_approved_comment',
          type: this.formType.TEXTAREA,
          rules: [],
          is_show: this.timerObj.state === CONSTANTS.NOT_APPROVED, // this.timerObj.state === CONSTANTS.NOT_APPROVED ? false : true,
          disabled: true,
          label: this.$t('message.timer.notApproved'),
          class: 'xs12'
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.$t('message.common.update'),
          click: this.updateHandler,
          disabled: this.isReadOnly,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'info',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  watch: {
    'startPicker' (val) {
      if (val) {
        this.filterObj.start = this.$format.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'endPicker' (val) {
      if (val) {
        this.filterObj.end = this.$format.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'timerObj.datePicker' (val) {
      if (val) {
        this.timerObj.date = this.$format.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    }
  }
}
</script>

<style>

</style>
